import { render } from "./AmountGroupCol.vue?vue&type=template&id=27837acd"
import script from "./AmountGroupCol.vue?vue&type=script&lang=js"
export * from "./AmountGroupCol.vue?vue&type=script&lang=js"

import exportComponent from "D:\\cwzl\\cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__